import Vue from 'vue';
import { marked } from 'marked';

Vue.filter('capitalize', (value) => {
  const word = value;
  if (!word) return '';
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
});

// eslint-disable-next-line consistent-return
Vue.filter('truncate', (value, limit) => {
  if (value) {
    if (value && value.length <= limit) {
      return value;
    }
    return `${ (value || '').substring(0, limit) }...`;
  }
});

Vue.filter('tailing', (value, tail) => value + tail);
Vue.filter('avatarName', (str) => (
  !str
    ? ''
    : str.split(/\s/)
      .reduce((memo, word) => `${memo}${word.slice(0, 1)}`, '')
      .slice(0, 2)
      .toUpperCase()
));

Vue.filter('time', (value, is24HrFormat = false) => {
  let timeReturn = '';
  if (value) {
    let time = '';
    const date = new Date(Date.parse(value));
    let hours = date.getHours();
    const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    if (!is24HrFormat) {
      time = hours > 12 ? 'AM' : 'PM';
      hours = hours % 12 || 12;
      return `${hours }:${ min } ${ time}`;
    }
    timeReturn = `${hours}:${min} ${time}`;
  }
  return timeReturn;
});

Vue.filter('date', (value, fullDate = false) => {
  const date = value.slice(8, 10).trim();
  const month = value.slice(4, 7).trim();
  const year = value.slice(11, 15);

  if (!fullDate) return `${date } ${ month}`;
  return `${date } ${ month } ${ year}`;
});

Vue.filter('csv', (value) => value.join(', '));

Vue.filter('markdown', (value) => (value ? marked(value) : ''));

Vue.filter('fromNow', (value) => Vue.moment(value).fromNow());
Vue.filter('toEndOfDayFromNow', (value) => Vue.moment(value).endOf('day').fromNow());
Vue.filter('dateFormat', (value) => Vue.moment(value).format('DD-MM-YYYY'));
Vue.filter('dateFormatTime', (value) => Vue.moment(value).format('DD-MM-YYYY HH:mm'));
Vue.filter('dateFormatDateTime', (value) => Vue.moment(value).format('DD-MM-YYYY HH:mm:ss'));
Vue.filter('dateFormatDateTimeLocal', (value) => Vue.moment(new Date(value)).format('DD-MM-YYYY HH:mm:ss'));
Vue.filter('dateCompleteFormat', (value) => Vue.moment(value).format('LLL'));
Vue.filter('dateTextFormat', (value) => Vue.moment(value).format('LLL'));

Vue.filter('filter_tags', (value) => value.replace(/<\/?[^>]+(>|$)/g, ''));

Vue.filter('k_formatter', (num) => (num > 999 ? `${(num / 1000).toFixed(1) }k` : num));

function calculateTimeAgo(seconds, dateString, abreviado) {
  const numdays = Math.floor(seconds / 86400);
  const numhours = Math.floor((seconds % 86400) / 3600);
  const numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
  if (numdays !== 0) {
    if (numdays > 5 && dateString) {
      return Vue.moment(dateString).format('DD-MM-YYYY HH:mm:ss');
    }
    if (abreviado) {
      return `${numdays} d ${numhours} hrs ${numminutes} min `;
    }
    return `${numdays} dias ${numhours} horas ${numminutes} minutos `;
  }
  if (numdays === 0 && numhours !== 0) {
    if (abreviado) {
      return `${numhours} hrs ${numminutes} min `;
    }
    return `${numhours} horas ${numminutes} minutos `;
  }
  if (numdays === 0 && numhours === 0 && numminutes !== 0) {
    if (abreviado) {
      return `${numminutes} min `;
    }
    return `${numminutes} minutos `;
  }
  if (numminutes === 0) {
    if (abreviado) {
      return `${numminutes} min`;
    }
    return `${numminutes} minutos`;
  }
  return numminutes;
}
Vue.filter('timeApprovals', (time, abreviado) => {
  const seconds = time * 60;
  return calculateTimeAgo(seconds, undefined, abreviado);
});
Vue.filter('timeAgo', (value, abreviado = false) => {
  const timeReturn = '';
  if (value) {
    const time = Date.parse(value);
    const nowTime = Date.now();
    const seconds = (nowTime - time) / 1000;
    return calculateTimeAgo(seconds, value, abreviado);
  }
  return timeReturn;
});
Vue.filter('formatSize', (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const kiloByte = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(kiloByte));
  return `${parseFloat((bytes / (kiloByte ** i)).toFixed(dm)) } ${ sizes[i]}`;
});
Vue.filter('toCurrency', (value) => {
  if (typeof value !== 'number') {
    return value;
  }
  const formatter = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP'
  });
  return formatter.format(value);
});
Vue.filter('amount', (value) => {
  if (!value) {
    return '';
  }
  if (value % 1 === 0) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  const val = (value / 1).toFixed(2).replace('.', ',');
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
});
